import { useMutation } from '@tanstack/react-query'

import type { ExactLocation } from 'src/features/consumers/schemas/consumer'
import { postRequest } from 'src/lib/api-client'

import type { Consumer } from '../schemas/consumer'

type ClientType = 'buy' | 'sell' | 'lease'

interface ConsumerStartJourneyRequest {
  firstName: string
  lastName: string
  phoneNumber: string
  gclid?: string
  fbclid?: string
  pageSource?: string

  /** The user ID of the user who is creating the consumer.
   * Set this to link to a professional's start journey button. */
  createdByUserId?: number

  /** Optional infomation */
  clientType?: ClientType
  exactLocation?: ExactLocation
}

export const consumerStartJourney = async (consumer: ConsumerStartJourneyRequest) => {
  const response = await postRequest<Consumer>('/consumers/start-journey', consumer)
  return response
}

export const useConsumerStartJourney = () => {
  return useMutation({
    mutationFn: consumerStartJourney,
  })
}
